"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioGroupLabel = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(RadioGroupLabel, _Component);

  function RadioGroupLabel() {
    (0, _classCallCheck3.default)(this, RadioGroupLabel);
    return (0, _possibleConstructorReturn3.default)(this, (RadioGroupLabel.__proto__ || (0, _getPrototypeOf2.default)(RadioGroupLabel)).apply(this, arguments));
  }

  (0, _createClass3.default)(RadioGroupLabel, [{
    key: "render",
    value: function render() {
      var option = this.props.option;

      return _react2.default.createElement("label", {
        className: "radio-group-label",
        htmlFor: option.id,
        dangerouslySetInnerHTML: { __html: option.title } });
    }
  }]);
  return RadioGroupLabel;
}(_react.Component), _class.propTypes = {
  option: _react.PropTypes.object.isRequired
}, _temp);
exports.default = RadioGroupLabel;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/form/RadioGroupLabel.js
 ** module id = 478
 ** module chunks = 0
 **/